<button [disabled]="!statesService.states.userCanClick">
  <ng-content></ng-content>
</button>
